import { Avatar, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Role } from "../Enums/Roles";
import DataSelect from "../components/DataInputs/DataSelect";
import DataTextField from "../components/DataInputs/DataTextField";
import Loader from "../components/Loader";
import { useAuth } from "../hooks/AuthContext";
import { ManagerCreate } from "../interfaces/Manager";
import { ResponseContainer } from "../interfaces/RequestBase";
import { RoleList } from "../interfaces/Role";
import {
	CreateManager,
	EditManager,
	GetManager,
	GetRoles,
} from "../requester/functions";
import { MAIN_URL } from "../requester/requester";
import VO, { VK, getUrlId } from "../utilities/validate";

interface IProps {
	userRole?: Role;
}

const managerTemplate: ManagerCreate = {
	first_name: "",
	last_name: "",
	email: "",
	phone: "",
	position: "",
	role: "",
	login: "",
	password: "",
};

const ManagerPage = (props: IProps) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { enqueueSnackbar } = useSnackbar();

	const [auth] = useAuth();

	const [manager, setManager] = useState<ManagerCreate>({ ...managerTemplate });
	const [editMode, setEditMode] = useState<boolean>(false);
	const [image, setImage] = useState<any>();
	const [avatar, setAvatar] = useState<any>(undefined);
	const [role, setRole] = useState<RoleList[]>([]);
	const [isLoaded, setIsLoaded] = useState<boolean>(false);

	const file = useRef<any>(undefined);

	useEffect(() => {
		GetRoles({}, (resp: ResponseContainer<RoleList[]>) => {
			if (resp.data) setRole(resp.data);
		});

		const idManager: string = getUrlId(location.pathname);
		if (idManager !== "create") {
			setEditMode(true);
			delete managerTemplate.password;
			GetManager(
				{ id_manager: parseInt(idManager) },
				(resp: ResponseContainer<ManagerCreate>) => {
					if (resp.status === "ok" && resp.data) {
						setManager(resp.data);
						setAvatar(`${MAIN_URL}manager/avatar/${resp.data.avatar}`);
						setIsLoaded(true);
					} else {
						navigate("/managers");
					}
				}
			);
		} else {
			setIsLoaded(true);
		}
	}, []);

	return isLoaded ? (
		<div className="w-full flex justify-between p-5">
			<div className="flex flex-col gap-3 w-2/5">
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"first_name"}
					inputProps={{
						label: "Имя",
						required: true,
						error: !VK(manager.first_name),
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"last_name"}
					inputProps={{
						label: "Фамилия",
						required: true,
						error: !VK(manager.last_name),
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"patronymic"}
					inputProps={{
						label: "Отчество",
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"email"}
					inputProps={{
						label: "Почта",
						required: true,
						error: !VK(manager.email),
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"phone"}
					inputProps={{
						label: "Телефон",
						required: true,
						error: !VK(manager.phone),
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"position"}
					inputProps={{
						label: "Должность",
						required: true,
						error: !VK(manager.position),
					}}
				/>
				{auth.role !== Role.manager ? (
					<DataSelect
						list={role}
						value={manager}
						setValue={setManager}
						keyValue={"role"}
						label={"Роль"}
					/>
				) : null}

				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"login"}
					inputProps={{
						label: "Логин",
						required: true,
						error: !VK(manager.login),
					}}
				/>
				<DataTextField
					value={manager}
					setValue={setManager}
					keyValue={"password"}
					inputProps={{
						label: "Пароль",
						required: true,
						error: !VK(manager.password),
					}}
				/>
				<div className="">
					<Button
						variant="contained"
						disabled={!VO(manager, managerTemplate) || (!image && !editMode)}
						onClick={() => {
							if (!editMode)
								CreateManager({ manager, image }, (resp) => {
									if (resp.status === "ok") {
										enqueueSnackbar("Пользователь создан", {
											variant: "success",
										});
										navigate("/managers");
									} else {
										enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
											variant: "error",
										});
									}
								});
							else
								EditManager({ manager, image }, (resp: any) => {
									if (resp.status === "ok") {
										enqueueSnackbar("Пользователь успешно обновлен", {
											variant: "success",
										});
									}
								});
						}}
					>
						Сохранить
					</Button>
				</div>
			</div>
			<div className="w-full flex justify-center ">
				<div
					className="relative w-[250px] h-[250px] group rounded-full"
					style={{ border: !editMode && !image ? "2px solid red" : "" }}
				>
					<Avatar sx={{ width: "100%", height: "100%" }} src={avatar} />
					<div className="group-hover:flex absolute left-0 top-0 w-full h-full hidden items-center justify-center rounded-full bg-[rgba(0,0,0,0.5)]">
						<input
							type="file"
							ref={file}
							style={{ display: "none" }}
							onChange={(ev) => {
								if (ev.target.files) {
									setImage(ev.target.files[0]);
									const fileReader = new FileReader();
									fileReader.readAsDataURL(ev.target.files[0]);
									fileReader.addEventListener("load", function () {
										setAvatar(this.result);
									});
								}
							}}
							accept="image/x-png,image/jpeg"
						/>
						<Button
							variant="contained"
							onClick={() => {
								file.current.click();
							}}
						>
							Выбрать
						</Button>
					</div>
				</div>
			</div>
		</div>
	) : (
		<Loader />
	);
};

export default ManagerPage;
